import React, { useState } from "react";
import axios from "axios";
import "./SignupNotification.css";

export const SignupNotification = () => {
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");
  const [loading, setLoading] = useState(false);

  const handleInputChange = (e) => {
    setEmail(e.target.value);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    // Basic email validation
    if (!email || !/\S+@\S+\.\S+/.test(email)) {
      setMessage("Please enter a valid email address.");
      return;
    }

    setLoading(true);
    setMessage("");

    try {
      const response = await axios.post("/api/notification", { email });

      // Axios automatically parses JSON responses
      const data = response.data;

      // If the response is successful
      setMessage("Thank you! You'll be notified when the site is live.");
      setEmail(""); // Clear input field
    } catch (error) {
      if (error.response?.status === 409) {
        // Handle duplicate email case
        setMessage("No need to sign up again! You're already on the list.");
      } else {
        // General error message
        console.error("Axios error:", error);
        setMessage(
          error.response?.data?.message || "An error occurred. Please try again."
        );
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="signup-container">
      <h1>SousPal</h1>
      <h4>If you can agree on any of the following then let SousPal be your second-in-command in the kitchen!</h4>
      <ul>
        <li>Want to know recipes based on what you have rather than what you need?</li>
        <li>Tired of the age old question of: <i>What's for dinner?</i> And even more tired of the response: <i>I don't know</i>.</li>
        <li>Want to use ingredients before they go bad with recommindations to use those ingredients?</li>
      </ul>
      <h4>Get Notified When We're Live</h4>
      <p>Enter your email below, and we'll let you know when the site launches!</p>
      <form onSubmit={handleSubmit}>
        <input
          type="email"
          placeholder="Your Email Address"
          value={email}
          onChange={handleInputChange}
        />
        <button type="submit" disabled={loading}>
          {loading ? "Submitting..." : "Sign Up"}
        </button>
      </form>
      {message && <p className="message">{message}</p>}
    </div>
  );
};
